import { Serializer } from 'survey-core';

export const registerCustomProperties = () => {
  Serializer.addProperty('page', {
    name: 'skipInStepper',
    category: 'general',
    visibleIndex: 0
  });
  Serializer.addProperty('page', {
    name: 'completePage',
    category: 'general',
    visibleIndex: 0
  });
  Serializer.addProperty('page', {
    name: 'stepName',
    category: 'general',
    visibleIndex: 0
  });
  Serializer.addProperty('page', {
    name: 'stepNumber',
    category: 'general',
    visibleIndex: 0
  });
  Serializer.addProperty('itemvalue', {
    name: 'tooltip:string'
  });
  Serializer.addProperty('itemvalue', {
    name: 'iconSrc:string'
  });
  Serializer.addProperty('question', {
    name: 'parentClassName'
  });
  Serializer.addProperty('question', {
    name: 'questionRef'
  });
};
